import React, { useEffect, useState, useMemo } from 'react';
import { Card, Row, Col, Switch, Justify, Bubble } from 'tea-component';
import useIntlExtend from '@/pages/intelligence/hooks/useIntlExtend';
import { getDataSourceIcon } from '@/pages/intelligence/utils/getDataSourceImg';
import Loading from '@/pages/intelligence/components/Loading';
import OverviewCard from '@/pages/intelligence/components/OverviewCard';
import classnames from 'classnames';
import NoData from '@/pages/intelligence/components/NoData';
import { COMPETITOR_GUIDE_CLASSNAMES } from '@intelligence/components/UserGuide/Competitor';
import { getCountryFlag } from '@/pages/home/_config/countries';
import SourceExplanation from '@/pages/intelligence/components/SummaryCard/components/SourceExplanation';
// import useSummarySourceState from '@/pages/intelligence/components/SummaryCard/useSummarySourceState';
import SummaryCard from '@/pages/intelligence/components/SummaryCard';
import TimeType from '@/pages/intelligence/components/TimeType';
import TipContext from '@home/components/TipContext';
import { DATASOURCE_NAME, DataSourceBubbleInfo } from '@intelligence/components/DataSourceComponents';
import { dataSource } from '@intelligence/pages/MetricsCreditability/_config';
import { COUNTRY_IMG_US } from '@intelligence/v3/constants/region';

const USRevenueUnits = (props: any) => {
  const {
    gameId,
    setActiveId,
    setActiveSegment,
    activeId,
    moduleName,
    conditionMarket,
    entityType,
    isOperateRegion,
    getUSRevenueUnits,
    usRevenueUnitsLoading,
    usRevenueUnitsDatas,
  } = props;
  const DEFAULT_LIFETIME = 'lifetime';
  const { formatMessage, locale } = useIntlExtend();
  const [byPlatform, setByPlatform] = useState(true);
  const [openSource, setOpenSource] = useState(false);
  const [steamDateType, setSteamDateType] = useState(DEFAULT_LIFETIME);
  const LIFETIME_OPTIONS = [
    { text: formatMessage({ id: 'dbi_combine_usrevenue_lifetime' }), value: DEFAULT_LIFETIME },
    {
      text: formatMessage({ id: 'dbi_combine_usrevenue_d1after_release' }),
      value: 'd1 after release',
    },
    {
      text: formatMessage({ id: 'dbi_combine_usrevenue_w1after_release' }),
      value: 'w1 after release',
    },
    {
      text: (
        <div className="dbi-kpioverview-card__time-type-tip">
          <span>{formatMessage({ id: 'dbi_combine_usrevenue_m1after_release' })}</span>
          <TipContext className="icon-top" tipText={formatMessage({ id: 'dbi_metric_m1_after_release_definition' })} />
        </div>
      ),
      value: 'm1 after release',
    },
    {
      text: formatMessage({ id: 'dbi_combine_usrevenue_y1after_release' }),
      value: 'y1 after release',
    },
    {
      text: (
        <div className="dbi-kpioverview-card__time-type-tip">
          <span>{formatMessage({ id: 'dbi_combine_usrevenue_y1after_ea' })}</span>
          <TipContext className="icon-top" tipText={formatMessage({ id: 'dbi_metric_y1_after_ea_definition' })} AWidth={350}/>
        </div>
      ),
      value: 'y1 after ea',
    },
    { text: formatMessage({ id: 'dbi_combine_usrevenue_last_month' }), value: 'last month' },
  ];

  // const { openSource, handleClickSourceTips } = useSummarySourceState();

  useEffect(() => {
    getUSRevenueUnits(DEFAULT_LIFETIME);
  }, []);

  const onChangeTimeType = (value: any) => {
    setSteamDateType(value);
    getUSRevenueUnits(value);
  };

  const changeDevice = (value: boolean) => {
    setByPlatform(value);
  };
  const changeOpenSource = () => {
    setOpenSource(!openSource);
  };

  const platformCur = useMemo(() => {
    let openStatus = false;
    // eslint-disable-next-line no-restricted-syntax
    for (const n in usRevenueUnitsDatas) {
      if (usRevenueUnitsDatas[n]?.platformList?.length > 0) {
        openStatus = true;
      }
    }
    return openStatus;
  }, [usRevenueUnitsDatas]);

  const conditionDateCur = useMemo(() => {
    const conditionDateMap: Record<string, string> = {
      'd1 after release': 'day',
      'w1 after release': 'day',
      'm1 after release': 'day',
      'last month': 'day',
    };
    return conditionDateMap[steamDateType] || 'month';
  }, [steamDateType]);

  return (
    <Card className="dbi-performance-summary dbi-kpioverview-card">
      <Card.Body
        title={
          <div className="performance-felx">
            <Bubble
              content={
                <div>
                  <DataSourceBubbleInfo
                    comesFormDom={
                      <>
                        <img
                          className="platform-title-icon"
                          style={{
                            height: '20px',
                            width: '20px',
                            margin: '0 4px',
                            verticalAlign: 'middle',
                          }}
                          src={getDataSourceIcon('mscience')}
                        />
                        {DATASOURCE_NAME['mscience']}
                        <div>{formatMessage({id: 'dbi_combine_us_mscience_one_tip'})}</div>
                        <div>{formatMessage({id: 'dbi_combine_us_mscience_two_tip'})}</div>
                        <div>{formatMessage({id: 'dbi_combine_us_mscience_three_tip'})}</div>
                      </>
                    }
                    metricKey={'Digital Revenue,Digital Units'}
                    dataSource={'mscience'}
                    entityType={entityType}
                  />
                </div>
              }
            >
              <div className="performance-felx">
                <img src={getDataSourceIcon('mscience')} className="dbi-pcGame-select-icon" style={{ height: '20px', width: '20px' }} />
              </div>
            </Bubble>
            <img style={{marginRight: 6, width: 18, height: 12}} src={COUNTRY_IMG_US} alt=""/>
            <span className="performance-felx-text">{formatMessage({id: 'dbi_combine_usrevenue_units'})}</span>
            <TipContext className="icon-top" tipText={formatMessage({id: 'dbi_combine_us_revenue_units_tip'})}/>
          </div>
        }
      >
        {openSource && <SummaryCard isSourceTips={true} openSource={openSource} />}

        <Justify
          className="dbi-pcGame-jf pc-metricstable-jf dbi-card-justify"
          left={
            <TimeType
              lightTheme={false}
              locale={locale}
              onConfirm={(val: any) => {
                onChangeTimeType(val);
              }}
              defaultValue={DEFAULT_LIFETIME}
              value={steamDateType || ''}
              optionsList={LIFETIME_OPTIONS}
            />
          }
          right={
            platformCur && (
              <Switch
                value={byPlatform}
                onChange={(value) => {
                  changeDevice?.(value);
                }}
              >
                {formatMessage({ id: `dbi_by_platform` })}
              </Switch>
            )
          }
        />

        {/* 加载中 */}
        {usRevenueUnitsLoading && (
          <Loading content={formatMessage({ id: 'common_loading' })} style={{ height: 142, color: '#444' }} />
        )}

        {/* 加载结束后有数据  */}
        {!usRevenueUnitsLoading && usRevenueUnitsDatas?.length > 0 && (
          <>
            <Row>
              {usRevenueUnitsDatas?.map((item: any, index: number) => {
                return item.titleIcon === 'viewers' ? null : (
                  <Col span={12}>
                    <OverviewCard
                      key={`indicator${item.titleContent}`}
                      className={classnames({
                        [COMPETITOR_GUIDE_CLASSNAMES.ELEMENT4]: item?.metricUserGuide === 'digitalRevenue',
                      })}
                      titleContent={item.titleContent}
                      titleIcon={item.titleIcon}
                      baseIndicators={item.baseIndicators}
                      numArrowData={item.numArrowData}
                      lineData={item.lineData}
                      lineDom={item.lineDom}
                      rankData={item.rankData}
                      index={index}
                      moduleName={moduleName}
                      entityType={entityType}
                      // rankLoading={rankLoading}
                      setActiveId={setActiveId}
                      conditionDate={conditionDateCur}
                      conditionMarket={conditionMarket}
                      gameId={gameId}
                      activeId={activeId}
                      cardItem={item}
                      setActiveSegment={setActiveSegment}
                      isOperateRegion={isOperateRegion}
                      ifShowPlatform={byPlatform}
                      data_source={'US Revenue & Units'}
                      isShowDataSourceIcon={false}
                      isShowRateTips={true}
                      query={{ region: 'us' }}
                      fullLabelBreakpoint={1800}
                    />
                  </Col>
                );
              })}
            </Row>
          </>
        )}

        {/* 加载结束后无数据  */}
        {!usRevenueUnitsLoading && !usRevenueUnitsDatas?.length && <NoData />}
      </Card.Body>
    </Card>
  );
};

export default USRevenueUnits;
